@if (!hideBreadCrumb) {
  <nav class="my-breadcrumbs hide--print" aria-label="Breadcrumb">
    <ul class="my-breadcrumbs__link-list">
      @for (crumb of breadcrumbs(); track $index; let i = $index; let isLast = $last) {
        @if (!isLast) {
          <li>
            <a class="my-breadcrumbs__link" [routerLink]="crumb.route" [queryParams]="crumb.queryParams" [class.no-link]="!crumb.route">
              <span class="my-breadcrumbs__text">{{ crumb.text }}</span>
              @if (i < crumbs.length - 1) {
                <span class="my-breadcrumbs__separator">
                  <svg focusable="false" fill="currentColor" width="20" height="20" aria-hidden="true">
                    <use href="assets/images/icons.svg?v=23112101#chevron-right"></use>
                  </svg>
                </span>
              }
            </a>
          </li>
        }
        @if (isLast) {
          <li class="no-link">
            <span class="my-breadcrumbs__text">{{ crumb.text }}</span>
          </li>
        }
      }
    </ul>
  </nav>
}